<template>
  <div class="jc-page-container">
    <div class="jc-page-header">
      <el-page-header title="渠道资源账单" />
    </div>

    <div class="jc-page-content">
      <el-alert
        class="mb-16px"
        title="注：账单总览为按月汇总的消费数据，本月数据可能会有延迟，实时数据请您查看明细账单；"
        type="warning"
        :show-icon="false"
        :closable="false"
      />

      <div class="jc-page-card pb-0px">
        <el-form
          :collapse="true"
          label-width="80px"
          label-position="left"
          :model="form"
          ref="formRef"
          :defaultCollapsed="false"
        >
          <el-form-item label="账期：" prop="billDate">
            <DateSelect
              v-model="form.billDate"
              :dateType="form.queryTimeType"
            />
          </el-form-item>
          <el-form-item label="产品线：" prop="service">
            <product-line-select
              v-model="form.service"
              @onChange="productChange"
            />
          </el-form-item>

          <el-form-item label="产品：" prop="serviceCode">
            <el-select v-model="form.serviceCode" clearable>
              <el-option
                v-for="(item, index) in serviceCodeList"
                :key="index"
                :label="item.serviceCodeName"
                :value="item.serviceCode"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="计费类型:" prop="billingType">
            <el-select v-model="form.billingType">
              <el-option
                v-for="(item, index) in CHARGE_TYPE"
                :label="item.key"
                :key="index"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="地域:" prop="region">
            <RegionList v-model="form.region" class="servicesLineSelect" />
          </el-form-item>
          <el-form-item label="资源ID:" prop="resourceId">
            <el-input v-model="form.resourceId" />
          </el-form-item>
          <el-form-item label="渠道账户:" prop="pin" :colSize="2">
            <UserSelect v-model="form.pin" class="servicesLineSelect" />
          </el-form-item>

          <template slot="action">
            <el-button type="primary" @click="search">查询</el-button>

            <el-button @click="resetForm">重置</el-button>
          </template>
        </el-form>
      </div>
      <!-- 费用总览 -->
      <div class="jc-page-card">
        <span class="text-20px">费用总览</span>

        <el-table :data="feeList" style="width: 100%" class="mt-16px">
          <el-table-column prop="date" label="费用总计">
            <template v-slot:default="{ row }">
              {{
                row.billFee +
                row.discountFee +
                row.cashPayFee +
                row.payCouponFee +
                row.freeCouponFee
              }}
            </template>
          </el-table-column>

          <el-table-column prop="billFee" label="原价"> </el-table-column>

          <el-table-column prop="discountFee" label="优惠金额">
          </el-table-column>

          <el-table-column prop="cashPayFee" label="现金支付">
          </el-table-column>

          <el-table-column prop="payCouponFee" label="付费代金券">
          </el-table-column>

          <el-table-column prop="freeCouponFee" label="免费代金券">
          </el-table-column>

          <el-table-column prop="arrearFee" label="欠费金额"> </el-table-column>

          <el-table-column label="操作" fixed="right" width="200px">
            <template>
              <ExportBill :Fn="exportOverviewBill" :title="title" />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="jc-page-card">
        <el-table ref="table" class="jc-list__table" :data="tableData">
          <el-table-column label="资源ID" prop="resourceId" />

          <el-table-column label="产品名称" prop="appCodeName" />

          <el-table-column label="支付人" prop="payerId" />

          <el-table-column label="使用人" prop="userId" />

          <el-table-column label="用户PIN" prop="pin" />

          <el-table-column label="计费类型" prop="billingTypeName" />

          <el-table-column label="地域" prop="regionName" />

          <el-table-column label="配置详情" prop="formulaDesc" />

          <el-table-column label="计费时间段" prop="timeRange" />

          <el-table-column label="消费类型" prop="consumeTypeName" />

          <el-table-column label="账单类型" prop="billTypeName" />

          <el-table-column label="原价" prop="billFee" />

          <el-table-column label="优惠金额" prop="discountFee" />

          <el-table-column label="应付费用" prop="actualFee" />

          <el-table-column label="现金支付" prop="cashPayFee" />

          <el-table-column label="付费代金券支付" prop="payCouponFee" />

          <el-table-column label="免费代金券支付" prop="freeCouponFee" />

          <el-table-column label="欠费金额" prop="arrearFee" />

          <el-table-column label="操作" fixed="right">
            <template v-slot:default="{ row }">
              <el-button
                @click="
                  $router.push({
                    name: 'billDetails',
                    query: {
                      pin: form.pin,
                      billDate: form.billDate,
                      serviceCode: row.serviceCode,
                      appCode: row.appCode,
                    },
                  })
                "
                type="text"
                size="small"
                >查看明细</el-button
              >
            </template>
          </el-table-column>
        </el-table>

        <div class="jc-list__action-bar">
          <div class="jc-list__action-bar--right">
            <el-pagination
              layout="total, sizes, prev, pager, next, jumper"
              :page-size="form.pageSize"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :total="total"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DateSelect from '@/views/channel/components/DateSelect.vue'
import UserSelect from '@/views/channel/components/UserSelect.vue'
import RegionList from '@/views/channel/components/RegionList.vue'
import ExportBill from '@/views/channel/components/ExportBill.vue'
import ProductLineSelect from '@/components/ProductLineSelect.vue'
import { ref, reactive, computed, toRefs, nextTick } from '@vue/composition-api'
import { CHARGE_TYPE } from '@/utils/constant.js'
import {
  describeResourceBills,
  describeBillSummary,
  exportResourceBills,
} from '@/api/channel-api.js'
import { Message } from '@jdcloud/jelement-next'
export default {
  // 组件名称
  name: 'resourceBilling',
  props: {},
  components: {
    DateSelect,
    UserSelect,
    RegionList,
    ExportBill,
    ProductLineSelect,
  },
  setup() {
    const state = reactive({
      serviceCodeList: [],
      form: {
        queryTimeType: 'month',
        billingType: '',
        service: '',
        serviceCode: '',
        billDate: '',
        pin: '',
        region: '',
        resourceId: '',
        dateTime: [],
        pageIndex: 1,
        pageSize: 10,
      },
      appCode: '-1',
      serviceCode: '-1',
      tableData: [],
      feeList: [],
      total: 0,
    })
    const formRef = ref(null)
    const params = computed(() => {
      const {
        region,
        pin,
        resourceId,
        serviceCode,
        service,
        queryTimeType,
        pageIndex,
        pageSize,
        billDate,
      } = state.form
      let param = {
        region,
        pin,
        resourceId,
        serviceCode,
        appCode: service,
        queryTimeType,
        billDate,
        pageIndex,
        pageSize,
      }
      Object.keys(param).forEach((key) => {
        if (param[key] === '') {
          delete param[key]
        }
      })
      return param
    })
    const resetForm = () => {
      formRef.value.resetFields()
      state.appCode = ''
      state.serviceCode = ''
      state.form.pin = ''
    }
    const productChange = (serviceCodes) => {
      state.serviceCodeList = serviceCodes
      state.form.serviceCode = ''
    }
    const exportOverviewBill = async () => {
      try {
        const { result } = await exportResourceBills({
          params: {
            ...params.value,
          },
        })
        Message.success(result.message)
        const url = derivativeConfig.exportUrl
        window.open(url)
      } catch (error) {
        console.log(error)
      }
    }
    const title = computed(() => {
      return state.form.billDate.replace(
        /(\d{4})-(\d{2})/,
        (match, year, month) => {
          return `下载${year}年 ${parseInt(month)}月账单`
        },
      )
    })
    const search = async () => {
      try {
        getExpenseSummary()
        const {
          result: { result, pagination },
        } = await describeResourceBills({
          params: params.value,
        })
        state.tableData = result
        state.total = pagination.numberRecords
      } catch (e) {
        console.error(e)
        state.tableData = []
        state.total = 0
      }
    }
    nextTick(() => {
      search()
    })

    const handleSizeChange = (val) => {
      state.form.pageSize = val
      search()
    }
    const handleCurrentChange = (val) => {
      state.form.pageIndex = val
      search()
    }
    async function getExpenseSummary() {
      try {
        const {
          result: { result },
        } = await describeBillSummary({
          params: {
            ...params.value,
            pageIndex: 1,
            pageSize: 10,
          },
        })
        state.feeList = [result]
      } catch (e) {
        console.error(e)
        state.feeList = []
      }
    }
    return {
      ...toRefs(state),
      resetForm,
      productChange,
      formRef,
      CHARGE_TYPE,
      search,
      title,
      exportOverviewBill,
      handleSizeChange,
      handleCurrentChange,
    }
  },
}
</script>
<style lang="less"></style>
